<template lang="pug">
  .filters-applied.xs-12(v-if="hasFilters")
    .xs-6
      p.xs-f-small.md-f-medium.max-at-tweak Filters applied:

    .xs-6.text-right
      button.clear-all-button.btn-reset.brand-color-1.xs-f-small.md-f-medium.max-at-tweak.text-right(@click="clearAllFilters")
        | Clear all
        span.ada-tooltip filters

    .active-filters.xs-12
      template(v-for="(filterArray, key) in filters")
        button.remove-filter-button.xs-f-xsmall.md-f-small.max-at-tweak(v-for="value in filterArray" :key="key + '-' + value" @click="toggleFilter({filter: key, value: value})")
          span.ada-tooltip remove&nbsp;
          span {{filterLabel(key, value)}}&nbsp;
          span.ada-tooltip  filter
          span.icon-x.xs-f-xxsmall.md-f-xsmall.max-at-tweak

</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex';

  export default {
    name: "FiltersApplied",

    computed: {
      ...mapState('reviews', ['filters']),
      ...mapGetters('reviews', ['filterLabel', 'hasFilters'])
    },

    methods: {
      ...mapMutations('reviews', ['toggleFilter', 'clearAllFilters'])
    }
  }
</script>

<style scoped lang="stylus">
  .filters-applied
    padding 1em 5%

    .clear-all-button
      text-decoration underline

    .active-filters
      padding-top 0.5em

    .remove-filter-button
      position relative
      border 1px solid color-fog-light
      border-radius 0.5em
      background-color color-white
      padding 0.5em 1em
      padding-right 2.25em
      margin 0.5em 0
      margin-right 1em

      .icon-x
        position absolute
        top 50%
        right 0.75em
        height 1.5em
        line-height 1.5em
        width 1.5em
        margin-top -0.75em
        border-radius 50%
        background-color brand-color-2
        color color-white
        display inline-block

        &:before
          margin 0

</style>
